export enum Gender {
  male = 'male',
  female = 'female',
  nonbinary = 'non-binary',
}
